<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout row wrap pa-3 pb-0>
                <v-flex lg6 md6 sm12>
                    <v-text-field v-model="staff.Username" ref="username" label="User Name" class="input-group--focused"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3 pt-0>
                <v-flex lg6 md6 sm12>
                    <v-text-field v-model="staff.Email" label="Email" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <v-text-field v-model="staff.FullName" label="Họ tên" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <v-select v-model="staff.RoleID" :items="role_list" item-text="name" item-value="value" label="Quyền hạn" class="input-group--focused"></v-select>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <v-autocomplete v-model="staff.StorageID" :items="storages" item-value="ID" item-text="Name" label="Kho nhận" autocomplete="off" :disabled="staff.RoleID != role_enum.Store"></v-autocomplete>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-switch v-model="staff.is_active" label="Trạng thái" class="input-group--focused"></v-switch>              
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import { mapState } from "vuex";
import md5 from "md5";
import configs from "@/configs";
export default {
    data() {
        return {
            role_list: _.filter(configs.ROLES, (obj) => { return obj.value != configs.ROLE_TYPE.Customer; }),
            role_enum: configs.ROLE_TYPE
        }
    },
    computed: {
        ...mapState({
            loading: state => state.staff.loading,
            staff: state => state.staff.selected,
            storages: state => state.storage.all.data,
        }),
        modifyId() {
            return this.$route.params.Pid;
        },
        locationStore() {
            return configs.LOCATION_STORE;
        },
        csRoleID() {
            return configs.ROLE_TYPE.CustomerService;
        },
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("staff/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("staff/setDetail", { data: {
                        ID: 0,
                        Username: '',
                        Email: '',
                        Password: md5('Apl@68'),
                        RoleID: 0,
                        ReceivePlaceID: 1,
                        is_active: 0,
                        is_admin: 0
                    }
                })
            }
            this.$nextTick(() => this.$refs.username.focus());
        },
        saveData() {
            this.$store.dispatch("staff/setDetail", {
                data: this.staff,
                id: this.staff.ID,
                param: {pagination: configs.PAGINATION}
            });
            window.getApp.$emit("APP_NAVIGATE", "StaffList");
        },
    },
    mounted() {
        this.refreshData();
        this.$store.dispatch("storage/getList");
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.staff.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
